import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRouterStore = defineStore('router', () => {
  const initialLoading = ref(true)
  const serverError = ref(false)
  return { initialLoading, serverError }
})
